import { render, staticRenderFns } from "./SSO.vue?vue&type=template&id=289cc57e"
import script from "./SSO.vue?vue&type=script&lang=js"
export * from "./SSO.vue?vue&type=script&lang=js"
import style0 from "./SSO.vue?vue&type=style&index=0&id=289cc57e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports